/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { SERVER_URL_REGEX } from '../../util/regex';

/**
 * Utilities used for validating preview URL uploads.
 */

/**
 * The layouts web chat can be rendered in preview pages for demo purposes.
 */
export enum WebChatLayoutMode {
  DEFAULT = 'default',
  FULLSCREEN = 'fullscreen',
  SIDEBAR = 'sidebar'
}

/**
 * Makes sure the full URL starts with either "http" or "https".
 *
 * @param url The URL to validate
 */
export const validHttpUrlCheck = (url: string): boolean =>
  SERVER_URL_REGEX.test(url);
